import type { ActionModeMap, CapabilityBinding, DeployAccessPolicy, FieldMode } from '../../core/types';
import { getCapability } from './registry';
import type { CapabilityControlProps } from './types';

/** 将 L3 accessPolicy 映射为 capability 受控 props */
export function buildCapabilityControl(binding: CapabilityBinding, accessPolicy?: DeployAccessPolicy): CapabilityControlProps {
  const bindingKey = String(binding.key);
  const def = getCapability(bindingKey);
  if (!def) {
    throw new Error(`Capability not registered: ${bindingKey}`);
  }

  const fieldModes: Record<string, FieldMode> = {};
  for (const field of def.fields) {
    fieldModes[field] = accessPolicy?.field(field) ?? 'editable';
  }

  const actionModes: ActionModeMap = {};
  for (const action of def.actions ?? []) {
    actionModes[action] = accessPolicy?.action(action) ?? 'enabled';
  }

  return { fieldModes, actionModes };
}
